import { Switch, Tooltip } from '@mui/material';
import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import LABELS from './keys';
import { Label, StyledExclamationCircledIcon, StyledTooltip, Wrapper } from './styles';

interface Props {
  value: boolean;
  setValue: Dispatch<SetStateAction<boolean>>;
}

const SettingsSwitch = ({ value, setValue }: Props) => {
  const { t } = useTranslation();
  const handleChange = (event: ChangeEvent<HTMLInputElement>, checked: boolean) => {
    setValue(checked);
  };

  return (
    <Wrapper>
      <Switch checked={value} onChange={handleChange} />
      <Tooltip slots={{ tooltip: StyledTooltip }} placement="right" title={t(LABELS.TOOLTIP)}>
        <Label>{t(LABELS.LABEL)}</Label>
      </Tooltip>
      <StyledExclamationCircledIcon />
    </Wrapper>
  );
};

export default SettingsSwitch;
